/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

import "./src/styles/css/bootstrap.min.css"
import "./src/styles/css/animate.min.css"
import "./src/styles/css/boxicons.min.css"
import "./src/styles/css/flaticon.css"
import "react-accessible-accordion/dist/fancy-example.css"
import "react-18-image-lightbox/style.css"
import "/node_modules/aos/dist/aos.css"
import "swiper/css"
import "swiper/css/bundle"

// Global style
import "./src/styles/css/style.scss"
import "./src/styles/css/responsive.scss"
import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

const recaptchaSiteKey = process.env.GATSBY_RECAPTCHA_PUBLIC_SITE_KEY

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      useRecaptchaNet
      scriptProps={{ async: true, defer: true, appendTo: "body" }}
    >
      {element}
    </GoogleReCaptchaProvider>
  )
}

// If you want RTL style comment out the below rtl.css
// import "./src/styles/css/rtl.css"
